import React from 'react';
import '../../styles/_PhraseAnimation.css';
import { Row, Col } from "react-bootstrap";

const Phrase = ({isSpanish}) => {
    return (
        <Row id='phrase__container'>
            <Col lg={2} md={2} lgOffset={5} mdOffset={5} smOffset={5} xsHidden>
                {isSpanish === true ? <div><h3>Pasión no es aquello que haces bien;<br/>es lo que más disfrutas hacer</h3></div>
                    : <div><h3>Passion is not what you're good at;<br/>it's what you enjoy the most.</h3></div>}
            </Col>
        </Row>
    )
}

export default Phrase;


// WEBPACK FOOTER //
// ./src/components/Home/Phrase.js